import React from 'react'
import { Box, Typography, Card, CardContent } from '@mui/material';
import {BoldSpan} from '../StyledSpan'
import SearchResultCountDisplay, {SearchResultCountDisplayProps} from './SearchResultCountDisplay'
import {COMMON_CONSTANTS} from '../../CommonConstants'

interface SearchFormProps {
    children: React.ReactNode
}

export const SearchFormCategory: React.FC<SearchFormProps> = props =>
    <Box mr={'10px'}>
        <Typography display={'inline'}><BoldSpan>{props.children}</BoldSpan></Typography>
    </Box>

interface Props {
    searchResult?: SearchResultCountDisplayProps
    onEnterKey?: (event: React.KeyboardEvent) => void
    children?: React.ReactNode
}

const ListSearchFormArea: React.FC<Props> = props => {
    const handleKeyPress = (event: React.KeyboardEvent): void => {
        if (event.which !== COMMON_CONSTANTS.ENTER_KEY_CODE) {
            return
        }
        if (props.onEnterKey) {
            props.onEnterKey(event)
        }
    }

    return (
        <>
            {
                props.children &&
                <Card>
                    <CardContent onKeyPress={handleKeyPress}>
                        {props.children}
                    </CardContent>
                </Card>
            }
            {
                props.searchResult &&
                <SearchResultCountDisplay {...props.searchResult} />
            }
        </>
    )
}

ListSearchFormArea.displayName = 'ListSearchFormArea'
export default ListSearchFormArea
